import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzIconModule } from '@blk/daisy/core/icon';
import { DzCardModule } from '@blk/daisy/modules/cards';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { CoreModule } from '@ddt-web/data-layer-components';
import { DataServiceModule } from '@ddt-web/data-service';
import { DomModule } from '@ddt-web/dom';
import { NewChartModule } from '@ddt-web/highchart-manager';

import { ChartTableCardItemComponent } from './chart-table-card-item.component';

@NgModule({
	declarations: [
		ChartTableCardItemComponent
	],
	imports: [
		CommonModule,
		AnalyticsModule,
		SharedModule,
		CwpNgFrameworkModule,
		NewChartModule,
		CoreModule,
		DataServiceModule,
		DzIconModule,
		DomModule,
		DzCardModule
	],
	exports: [
		ChartTableCardItemComponent
	]
})
export class ChartTableCardItemModule { }
